<script>
  export let buttons;
</script>

{#each buttons as button}
<a class="btn btn-{button.type}" target="_blank" href="{button.url}">{button.type}</a>
{/each}

<style>
  a.btn {
    font-family: inherit;
    font-size: inherit;
    padding: 0.4em 0.75em;
    margin: 0 0.25em 0.5em 0.25em;
    box-sizing: border-box;
    border: 1px solid #ccc;
    border-radius: 2px;
    display: inline-block;
  }
  a.btn {
    color: #333;
    background-color: #f4f4f4;
    outline: none;
    font-weight: bold;
    margin: 5px;
    white-space: nowrap;
    font-weight: bold;
    padding: 10px 15px;
  }
  a.btn-Venmo {
    background-color: #3d95ce;
    border-color: #3d95ce;
    color: white;
  }

  a.btn-Cash {
    background-color: #0abe49;
    border-color: #0abe49;
    color: white;
  }

  a.btn-PayPal {
    background-color: #0070ba;
    border-color: #0070ba;
    color: white;
  }

  a.btn-GoFundMe {
    background-color: white;
    border-color: #00b964;
    color: #00b964;
  }

  a.btn-Fundly {
    background-color: white;
    border-color: #2996bc;
    color: #2996bc;
  }
  a.btn:focus {
    border-color: #666;
  }

</style>
